export const MAX_PET_SEARCH_RETRIES = 20;
